import { defineComponent as p, h as e } from "vue";
let u = 0;
const a = {
  title: String
};
function m({ name: r, xOffset: o = 0, yOffset: l = 0, width: s, height: c, svgPath: d }) {
  const i = p({
    name: r,
    render() {
      const n = `icon-title-${u++}`, h = [o, l, s, c].join(" "), t = [];
      return this.title && t.push(e("title", { id: n }, this.title)), t.push(e("path", { d })), e("svg", {
        class: "pf-v6-svg",
        fill: "currentColor",
        viewBox: h,
        "aria-labelled-by": this.title ? n : void 0,
        "aria-hidden": this.title ? void 0 : !0,
        role: "img",
        width: "1em",
        height: "1em"
      }, t);
    }
  });
  return i.props = a, i;
}
export {
  m as createIcon
};
